import React, { useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import 'tailwindcss/tailwind.css'; // Make sure you have tailwindcss installed and imported
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(ArcElement, Tooltip, Legend);

const NPSCalculator = () => {
  const [monthlyInvestment, setMonthlyInvestment] = useState(10000);
  const [expectedReturn, setExpectedReturn] = useState(10);
  const [currentAge, setCurrentAge] = useState(30);
  const [investedAmount, setInvestedAmount] = useState(0);
  const [interestReturn, setInterestReturn] = useState(0);
  const [maturityAmount, setMaturityAmount] = useState(0);
  const [minAnnuityInvestment, setMinAnnuityInvestment] = useState(0);

  // const calculateNPS = () => {
  //   const retirementAge = 60;
  //   const investmentPeriod = retirementAge - currentAge;
  //   const months = investmentPeriod * 12;
  //   const interestRate = expectedReturn / 100;
  //   let totalValue = 0;
  
  //   for (let i = 1; i <= months; i++) {
  //     totalValue = (totalValue + monthlyInvestment) * (1 + interestRate / 12);
  //   }
  
  //   const investedAmount = monthlyInvestment * months;
  //   const interestReturn = totalValue - investedAmount;
  //   const maturityAmount = totalValue;
  //   const minAnnuityInvestment = maturityAmount * 0.4;
  
  //   setInvestedAmount(investedAmount);
  //   setInterestReturn(interestReturn.toFixed(2));
  //   setMaturityAmount(maturityAmount.toFixed(2));
  //   setMinAnnuityInvestment(minAnnuityInvestment.toFixed(2));
  // };
  const calculateNPS = () => {
    const retirementAge = 60;
    const investmentPeriod = retirementAge - currentAge;
    const months = investmentPeriod * 12;
    const monthlyRate = expectedReturn / 100 / 12;
  
    const maturityAmount = monthlyInvestment * ((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate);
    const investedAmount = monthlyInvestment * months;
    const interestReturn = maturityAmount - investedAmount;
    const minAnnuityInvestment = maturityAmount * 0.4;
  
    setInvestedAmount(investedAmount);
    setInterestReturn(interestReturn.toFixed(2));
    setMaturityAmount(maturityAmount.toFixed(2));
    setMinAnnuityInvestment(minAnnuityInvestment.toFixed(2));
  };
  
  const handleMonthlyInvestmentChange = (e) => {
    const value = e.target.value;
    setMonthlyInvestment(value === '' ? 0 : parseInt(value));
  };

  const handleExpectedReturnChange = (e) => {
    const value = e.target.value;
    setExpectedReturn(value === '' ? 0 : parseFloat(value));
  };

  const handleCurrentAgeChange = (e) => {
    const value = e.target.value;
    setCurrentAge(value === '' ? 0 : parseInt(value));
  };

  const data = {
    labels: ['Invested Amount', 'Interest Return'],
    datasets: [
      {
        label: 'NPS Breakdown',
        data: [investedAmount, interestReturn],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
      {
        question: 'What is the minimum contribution required for NPS?',
        answer: 'The minimum contribution for Tier I is ₹500 per contribution and ₹1,000 per year.',
      },
      {
        question: 'Is NPS available for NRIs?',
        answer: 'Yes, NRIs can invest in NPS, but the account must be closed if their citizenship changes.',
      },
      {
        question: 'Can I have both Tier I and Tier II accounts?',
        answer: 'Yes, Tier II is optional and can only be opened if you have an active Tier I account.',
      },
      {
        question: 'Is the annuity amount from NPS taxable?',
        answer: 'Yes, annuity/pension received post-retirement is taxable as per your income tax slab.',
      },
      {
        question: 'Can I change my fund manager?',
        answer: 'Yes, you are allowed to switch your pension fund manager once a year.',
      },
      {
        question: 'Can I increase or decrease my contribution?',
        answer: 'Yes, contributions are flexible. You can increase or decrease the amount any time.',
      },
      {
        question: 'How much pension will I get from NPS?',
        answer: 'It depends on the accumulated corpus and the annuity plan you select at retirement.',
      },
      {
        question: 'Can I make a lump-sum contribution?',
        answer: 'Yes, lump-sum contributions are allowed anytime during the year.',
      },
      {
        question: 'Is NPS better than PPF or EPF?',
        answer: 'NPS offers better market-linked returns but carries more risk than PPF or EPF.',
      },
      {
        question: 'What is the lock-in period for NPS?',
        answer: 'NPS Tier I is locked in until the age of 60, with partial withdrawals allowed under specific conditions.',
      },
      {
        question: 'What happens to my NPS corpus if I die before retirement?',
        answer: 'The nominee receives the full accumulated corpus without mandatory annuitization.',
      },
      {
        question: 'How often is interest compounded in NPS?',
        answer: 'Returns are market-linked, not fixed, so there is no fixed compounding frequency like bank FDs.',
      },
      {
        question: 'What happens after retirement in NPS?',
        answer: 'You can withdraw up to 60% of the corpus tax-free; the rest must be used to buy an annuity.',
      },
      {
        question: 'Can I withdraw my NPS amount before maturity?',
        answer: 'Partial withdrawals up to 25% are allowed after 3 years for specific purposes like education, marriage, or medical emergencies.',
      },
      {
        question: 'Does the NPS calculator show exact results?',
        answer: 'No, it offers estimated returns. Actual outcomes may vary depending on fund performance and annuity rates.',
      },
    ];
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         <title>NPS Calculator – National Pension Scheme Returns Estimator</title>
        <meta  name='description' content='Plan your retirement with the NPS calculator. Estimate pension and maturity amount under National Pension Scheme.'/>
        <meta name='keywords' content='nps pension calculator, nps scheme calculator, national pension scheme sbi calculator, national pension plan calculator, national pension fund calculator, national pension scheme pension calculator, new pension scheme nps calculator, nps pension scheme calculator sbi' />
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/nps-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">NPS Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
        <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
    <div className="py-4">
      <div className="container mx-auto p-4 shadow-xl rounded-md">
        <h1 className="text-2xl font-bold mb-4">National Pension System Calculator</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Investment per Month</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  value={monthlyInvestment}
                  onChange={handleMonthlyInvestmentChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">₹ {monthlyInvestment.toLocaleString()}</span>
              </div>
              <input
                type="range"
                min="0"
                max="100000"
                value={monthlyInvestment}
                onChange={(e) => setMonthlyInvestment(parseInt(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Expected Return (p.a.)</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  max="100"
                  step="0.1"
                  value={expectedReturn}
                  onChange={handleExpectedReturnChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">{expectedReturn} %</span>
              </div>
              <input
                type="range"
                min="0"
                max="100"
                step="0.1"
                value={expectedReturn}
                onChange={(e) => setExpectedReturn(parseFloat(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Your Age</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="18"
                  max="60"
                  value={currentAge}
                  onChange={handleCurrentAgeChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">{currentAge} Yr</span>
              </div>
              <input
                type="range"
                min="18"
                max="60"
                value={currentAge}
                onChange={(e) => setCurrentAge(parseInt(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <button
              onClick={calculateNPS}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Calculate
            </button>
          </div>
          <div>
            <div className="mb-4">
              <h2 className="text-xl font-bold">Results</h2>
              <p>Invested Amount: ₹ {investedAmount.toLocaleString()}</p>
              <p>Interest Return: ₹ {interestReturn.toLocaleString()}</p>
              <p>Maturity Amount: ₹ {maturityAmount.toLocaleString()}</p>
              <p>Min. Annuity Investment: ₹ {minAnnuityInvestment.toLocaleString()}</p>
            </div>
            <div>
              <h2 className="text-xl font-bold">Breakdown</h2>
              <div className="flex justify-center">
                <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
    <div className="w-full md:w-2/3 p-4 mx-auto">
    <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            What is the National Pension System (NPS)?
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            The National Pension System is a voluntary, long-term retirement savings scheme initiated by the Government of India and regulated by the Pension Fund Regulatory and Development Authority (PFRDA). It allows individuals aged between 18 and 60 years to contribute systematically during their working years and withdraw a portion of the accumulated corpus after retirement, while the rest is used to purchase an annuity that provides a regular pension.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Unlike traditional fixed-return instruments, NPS offers market-linked returns through exposure to equities, corporate bonds, and government securities.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does NPS Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              When you enroll in the NPS, you create a Permanent Retirement Account Number (PRAN). You can choose between two types of accounts:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Tier I Account:</strong> The primary retirement account with withdrawal restrictions, designed for long-term savings.</li>
              <li><strong>Tier II Account:</strong> A voluntary savings facility with flexible withdrawal options, functioning more like a mutual fund.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Your contributions are invested in a diversified portfolio managed by professional pension fund managers, and the returns accumulate over time through compounding.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Should You Invest in NPS?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              NPS serves as an efficient way to build a sizable retirement corpus, benefiting from both disciplined contributions and market returns. Here are some of the key advantages:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Builds a Retirement Corpus:</strong> Regular contributions to NPS over the years allow individuals to accumulate a significant fund that can support them financially post-retirement. The power of compounding ensures your savings grow steadily over time.</li>
              <li><strong>Market-Linked Returns with Professional Management:</strong> Unlike fixed-income instruments, NPS invests in a mix of equity (E), corporate bonds (C), and government securities (G). You can select an Active Choice (self-select allocation) or Auto Choice (age-based allocation), depending on your risk appetite.</li>
              <li><strong>Attractive Tax Benefits:</strong> NPS comes with triple tax benefits:
                <ul className="list-disc pl-6">
                  <li>Up to ₹1.5 lakh under Section 80CCD(1) within the overall limit of Section 80C.</li>
                  <li>An additional ₹50,000 under Section 80CCD(1B).</li>
                  <li>Employer’s contribution (up to 10% of salary) is deductible under Section 80CCD(2) without any limit under Section 80C.</li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is an NPS Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An NPS Calculator is a digital tool that helps you estimate your total retirement corpus and monthly pension by factoring in your:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Monthly or annual contributions</li>
              <li>Expected rate of return</li>
              <li>Current age and retirement age</li>
              <li>Annuity purchase percentage</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              It saves time, eliminates manual computation, and allows users to visualize their retirement income potential clearly.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Benefits of Using an NPS Calculator
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using a smart tool like the NPS calculator offers several advantages, especially when you're planning for the long-term:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Instant Estimates:</strong> The calculator gives you an approximate maturity value based on your inputs. You can tweak the variables like contribution amount or rate of return to see how it impacts your retirement corpus.</li>
              <li><strong>Goal-Oriented Planning:</strong> By forecasting your expected retirement savings, the tool helps you set realistic goals and align your monthly contributions accordingly.</li>
              <li><strong>Retirement Clarity:</strong> It provides an idea of your monthly annuity/pension payout after retirement, helping you ensure a secure and sustainable lifestyle during your post-working years.</li>
              <li><strong>Flexible Analysis:</strong> Whether you're a conservative investor or someone looking to maximize returns, you can modify the investment tenure, risk strategy, and contribution frequency for comparative analysis.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              NPS Corpus and Annuity Estimation Formula
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              While most users rely on calculators, understanding the math behind NPS gives you better control over your finances. The compound interest formula is:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>A = P × (1 + r/n)^(nt)</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>A = Maturity amount</li>
              <li>P = Monthly contribution</li>
              <li>r = Annual interest rate (in decimals)</li>
              <li>n = Number of times interest is compounded annually</li>
              <li>t = Total investment tenure in years</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Keep in mind, at the time of retirement, a certain portion of the accumulated corpus (typically up to 60%) can be withdrawn as a lump sum, and the remaining must be used to buy an annuity plan, which pays out a monthly pension.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Using TheFinMaster NPS Calculator
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              TheFinMaster NPS Calculator is built to simplify your retirement planning journey. Here’s how you can use it:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Enter your current age.</li>
              <li>Input your desired monthly contribution.</li>
              <li>Select your expected rate of return (based on asset allocation).</li>
              <li>Choose your expected retirement age.</li>
              <li>View your estimated retirement corpus and monthly pension.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This helps you strategize your financial planning more effectively and adjust your monthly savings if needed.
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Important Considerations Before Investing in NPS
            </h2>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Liquidity:</strong> NPS has a long lock-in period until the age of 60. Partial withdrawals are allowed but with strict conditions.</li>
              <li><strong>Tax on Withdrawal:</strong> While 60% of the corpus is tax-free on withdrawal, the annuity income is taxable as per your income slab.</li>
              <li><strong>Annuity Rates:</strong> The monthly pension depends on the annuity plan you purchase and prevailing annuity rates at retirement.</li>
              <li><strong>Exit Rules:</strong> Premature exit is allowed after 10 years, but you must use 80% of the corpus to buy an annuity.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              NPS vs Other Retirement Options
            </h2>
            {/* <div className="overflow-x-auto mt-4">
              <table className="table-auto w-full border-collapse border border-gray-300">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="px-4 py-2 text-left">Feature</th>
                    <th className="px-4 py-2 text-left">NPS</th>
                    <th className="px-4 py-2 text-left">EPF</th>
                    <th className="px-4 py-2 text-left">PPF</th>
                    <th className="px-4 py-2 text-left">Mutual Funds</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-300 text-gray-600">
                  <tr>
                    <td className="px-4 py-2">Returns</td>
                    <td className="px-4 py-2">Market-linked (8%-10%)</td>
                    <td className="px-4 py-2">Fixed (8%-8.5%)</td>
                    <td className="px-4 py-2">Fixed (~7%-8%)</td>
                    <td className="px-4 py-2">Market-driven (10%-15%)</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">Risk</td>
                    <td className="px-4 py-2">Moderate</td>
                    <td className="px-4 py-2">Low</td>
                    <td className="px-4 py-2">Low</td>
                    <td className="px-4 py-2">High</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">Lock-in</td>
                    <td className="px-4 py-2">Till 60 years</td>
                    <td className="px-4 py-2">Till retirement</td>
                    <td className="px-4 py-2">15 years</td>
                    <td className="px-4 py-2">No lock-in</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">Tax Benefits</td>
                    <td className="px-4 py-2">Section 80C + 80CCD(1B)</td>
                    <td className="px-4 py-2">Section 80C</td>
                    <td className="px-4 py-2">Section 80C</td>
                    <td className="px-4 py-2">Section 80C (ELSS only)</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
        
          <div className="max-w-4xl mx-auto overflow-hidden rounded-lg border border-gray-300 shadow mt-6">
    {/* Header */}
    <div className="hidden md:grid grid-cols-5 bg-gray-800 text-white text-sm font-semibold text-center">
      <div className="px-3 py-2 border-r">Feature</div>
      <div className="px-3 py-2 border-r">NPS	</div>
      <div className="px-3 py-2 border-r">EPF	</div>
      <div className="px-3 py-2 border-r">PPF</div>

      <div className="px-3 py-2">Mutual Funds</div>
    </div>

    {/* Data rows for mobile (stacked) and desktop (grid) */}
    <div className="divide-y divide-gray-200 text-sm md:text-base text-gray-600 ">
      {/* Row Template */}
      {[
        {
          feature: "Returns",
          nps: "	Market-linked (8%-10%)",
          epf: "	Fixed (8%-8.5%)",
          ppf: "	Fixed (~7%-8%)",
          mutal: "	Market-driven (10%-15%)",
        },
        {
          feature: "Risk",
          nps: "	Moderate",
          epf: "		Low",
          ppf: "		Low",
          mutal: "	High",
        },
        {
          feature: "Lock-in",
          nps: "	Till 60 years",
          epf: "	Till retirement",
          ppf: "	15 years",
          mutal: "		No lock-in",
        },
        {
          feature: "Tax Benefits",
          nps: "	Section 80C + 80CCD(1B)",
          epf: "	Section 80C",
          ppf: "		Section 80C",
          mutal: "		Section 80C (ELSS only)",
        },
      
      ].map((row, idx) => (
        <div
          key={idx}
          className="block md:grid md:grid-cols-5 hover:bg-gray-50 transition"
        >
          {/* Mobile version */}
          <div className="block md:hidden px-4 py-3">
            <p className="font-semibold">Feature: <span className="font-normal">{row.feature}</span></p>
            <p className="font-semibold">NPS: <span className="font-normal">{row.nps}</span></p>
            <p className="font-semibold">EPF <span className="font-normal">{row.epf}</span></p>
            <p className="font-semibold">PPF <span className="font-normal">{row.ppf}</span></p>
            <p className="font-semibold">Mutual Funds <span className="font-normal">{row.mutal}</span></p>
          </div>

          {/* Desktop version */}
          <div className="hidden md:block px-4 py-3 border-r">{row.feature}</div>
          <div className="hidden md:block px-4 py-3 border-r">{row.nps}</div>
          <div className="hidden md:block px-4 py-3 border-r">{row.epf}</div>
          <div className="hidden md:block px-4 py-3 border-r">{row.ppf}</div>
          <div className="hidden md:block px-4 py-3">{row.mutal}</div>

        </div>
      ))}
    </div>
  </div>
          <h2 className="text-xl font-medium text-gray-700 mt-4">
            “Plan your retirement with confidence! Use TheFinMaster to explore the National Pension System and secure your financial future!”
          </h2>
          </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Conclusion: Plan Today for a Comfortable Tomorrow
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
            The National Pension System is a disciplined and structured approach to retirement savings, offering flexibility, market exposure, and tax incentives. Using an NPS calculator empowers you with insights into your retirement potential and enables smarter decision-making.

            </p>
        
            </div>
            <h2 className="text-xl font-medium text-gray-700 mt-4">
            Start early, contribute regularly, and use tools like TheFinMaster’s NPS Calculator to stay on track with your retirement goals.
          </h2>
        </div>

        <div className="w-full md:w-1/3 p-4">
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
              <h2 className="text-lg font-semibold ">Popular Categories</h2>
            </div>
            <div className="p-2 ">
            <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>

                        {/* Ad Banner */}
                      <div className="mt-4">
                        <div className="bg-white shadow-md rounded-lg overflow-hidden">
                          <div className="p-3 w-full h-auto rounded-md object-cover">
                            <AdBanner displayOrder="2" />
                          </div>
                        </div>
                      </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
                {/* {moreCategories.map(category => (
          <Link key={category.id} to={`/category/${category.id}`}>
            <li className="py-2 border-b border-gray-300">{category.name}</li>
          </Link>
        ))} */}
              </ul>
            </div>
          </div>

        </div>

      </div>

      <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
    </>
  );
};

export default NPSCalculator;
